
import React from "react";
import classes from "./videoSection.module.css";

function VideoSection(props) {
  return (
    <section className={classes.YouTubeSection}>
    <div className={classes.VideoContainer}>
      <iframe
        className={classes.YouTubeIframe}
        src={props.src}
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
    </div>
  </section>
  );
}

export default VideoSection;
